/**
 * Validates a password against format definitions
 */
const validatePassword = (password) => {
  // Mindestens 8, höchstens 32 Zeichen. Muss einen Buchstaben, sowie eine Ziffer oder eines der folgenden Sonderzeichen enthalten: # ( ) [ ] { } ? ! $ % & / = * + ~ , . : < > @ € - _
  /* eslint-disable-next-line no-useless-escape */
  const validChars = /^[A-Za-z\d#\\\/\?\!\$\%\&\=\[\]\(\)\{\}\*\+\,\.\:\<\>\@\€\-\_\§\^]{8,32}$/g.test(password)
  const hasNumbers = /[0-9]/.test(password)
  const hasAlpha = /[A-Za-z]/.test(password)
  /* eslint-disable-next-line no-useless-escape */
  const hasSpecial = /[#\\\/\?\!\$\%\&\=\[\]\(\)\{\}\*\+\,\.\:\<\>\@\€\-\_]/.test(password)
  return validChars && (hasNumbers || hasSpecial) && hasAlpha
}

export default {
  methods: {
    validatePassword
  }
}
